import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Image as ImageIcon } from "lucide-react";

/** Fetches + displays the Gemini-generated hero illustration for a chapter. */
export default function ChapterHero({ chapterId, title }) {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get(`/chapters/${chapterId}/hero`)
      .then((r) => { if (!cancelled) setImage(r.data?.image || null); })
      .catch(() => { if (!cancelled) setImage(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [chapterId]);

  // While loading, don't reserve space if we don't know if there's an image.
  if (loading || !image) return null;

  return (
    <div
      className="relative rounded-2xl overflow-hidden border border-border mb-6 bg-white"
      data-testid="chapter-hero"
    >
      <img
        src={image}
        alt={title || "Chapter illustration"}
        className="w-full h-44 sm:h-56 object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent pointer-events-none" />
      <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2 text-white">
        <ImageIcon className="w-3.5 h-3.5 opacity-70" />
        <span className="text-[10px] uppercase tracking-[0.2em] opacity-80">Illustration</span>
      </div>
    </div>
  );
}
